import React from 'react';
import PropTypes from 'prop-types';
import styles from './waveText.css';

const WaveText = ({ text, rate }) => {
  const letters = text.split('');
  const textRate = rate * 0.01;

  return (
    <div className={styles.wrapper}>
      <div className={styles.text}>
        {letters.map((letter, i) => (
          <span
            style={{ animationDelay: `${i * textRate}s` }}
            className={`${styles.letter} ${letter === ' ' ? styles.spacer : ''}`}
            key={i}>
            {letter}
          </span>
        ))}
      </div>
    </div>
  );
};

WaveText.propTypes = {
  text: PropTypes.string,
  rate: PropTypes.number,
};

export default WaveText;
